<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { SessionLightModel, SessionModel } from '@24hbs/utils';
	import { isValidDate } from '$lib/utils/formatter';
	import { LinkAction } from '$lib/components/atoms/Link';
	import ScheduleRadioButton from './ScheduleRadioButton.svelte';

  export let sessions: { [idSession: string]: SessionModel } = {};
  export let selectedSession: SessionModel | SessionLightModel =
    new SessionModel();
  export let showExpandButton: boolean | null = null;
  export let maxShowed = 3;
  export let hasVatFree: boolean = false;

  const dispatch = createEventDispatcher();
  const today = new Date(new Date().setHours(0, 0, 0, 0)).getTime();
  const validSessions: SessionModel | SessionLightModel[] = [];

  let validSessionCounter = 0;

  for (let session of Object.values(sessions)) {
    if (
      !session.startDate ||
      !isValidDate(session.startDate) ||
      ((isValidDate(session.startDate) && new Date(session.startDate).getTime() >= today) ||
      (session.buyButtonAvailable || session.admissionForm))
    ) {
      validSessions.push(session);
      validSessionCounter++;
    }
  }

  validSessions.sort((a, b) => {
    const startDateA = a.startDate || null;
    const startDateB = b.startDate || null;
    if (startDateA && startDateB) {
      return startDateA.getTime() - startDateB.getTime();
    }
    return 1;
  });

  let collapsed =
    showExpandButton === true ? false : validSessionCounter > 3 ? true : false;

  const onChange = (e: Event) => {
    const target = e.target as HTMLInputElement;
    let value: SessionModel = null;
    for (let sessionToCheck of Object.values(sessions)) {
      if (target.id === 'session-selector-' + sessionToCheck.idSession) {
        value = sessionToCheck;
      }
    }

    if (value === null) {
      return;
    }

    dispatch('change', {
      value,
    });
  };
</script>

<div class="course-schedule-selector">
  <fieldset
    class="selector-list space-y-6"
    class:collapsed
    on:change={onChange}
  >
    {#each validSessions as session, index}
      <ScheduleRadioButton
        id="session-selector-{session.idSession}"
        name="schedule"
        value={session.idSession.toString()}
        checked={selectedSession.idSession === session.idSession}
        {session}
        {hasVatFree}
        showLessionMode={validSessionCounter > 1}
      />
    {/each}
  </fieldset>

  {#if showExpandButton === true || (!showExpandButton && validSessionCounter > maxShowed)}
    <div class="selector-expander">
      <LinkAction
        iconPos="end"
        icon={collapsed ? 'plus' : 'minus'}
        on:click={() => (collapsed = !collapsed)}
      >
        {collapsed ? 'Mostra di più' : 'Mostra di meno'}
      </LinkAction>
    </div>
  {/if}
</div>

<style type="text/scss" lang="scss" scoped>
  .course-schedule-selector {
    @apply flex flex-col;
  }

  /* Hide all but the first three elements */
  :global(.selector-list.collapsed
      > *:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3))) {
    @apply hidden;
  }

  .selector-expander {
    @apply flex justify-end;
    @apply mt-6 mr-4 md:mr-0;
  }
</style>
